import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firebase-firestore";
import _ from "lodash";

class PeopleDataService {
  db;

  constructor() {
    this.db = firebase.firestore();
  }

  getAll = () => {
    return this.db
      .collection("people")
      .get()
      .then((docList) => {
        let items = [];
        docList.docs.forEach((doc) => {
          // console.log(doc.data());
          items.push(doc.data());
        });
        return items;
      })
      .catch((error) => error);
  };

  create = async (people) => {
    const batch = this.db.batch();
    people.map((item) => {
      const collectionRef = this.db.collection("people").doc(item.id);
      batch.set(collectionRef, item);
    });

    await batch
      .commit()
      .then()
      .catch((error) => error);
  };

  update = async (people) => {
    const batch = this.db.batch();
    people.map((item) => {
      const collectionRef = this.db.collection("people").doc(item.id);
      batch.set(collectionRef, item);
    });

    await batch
      .commit()
      .then()
      .catch((error) => error);
  };

  delete = (peopleIds) => {
    peopleIds.map((id) => {
      return this.db
        .collection("people")
        .doc(id)
        .delete()
        .then()
        .catch((error) => error);
    });
  };
}

export default new PeopleDataService();
